<template>
  <v-alert
    :value="true"
    dismissible
    type="warning"
  >
    <span
      v-html="settings.textGatePass"
    />
  </v-alert>
</template>

<script>
export default{

}
</script>
